var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('quill-editor',{ref:"editor",attrs:{"toolbar-options":[
				[{ 'header': [1, 2, 3, 4, 5, false] }],
				['bold', 'italic', 'underline'],
				['blockquote',{ 'list': 'ordered' }, { 'list': 'bullet' }],
				['glossary'] ]},on:{"input":_vm.storeText},model:{value:(_vm.localText),callback:function ($$v) {_vm.localText=$$v},expression:"localText"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }